/**
 * @file ReportAnIssue.js
 * @module src/js/components/ReportAnIssue
 * @description
 * **Component for reporting issues via email.**
 * - Prepares an email template with the current page URL and user-agent information.
 * - Uses the MailTo component to open the user's default email client with pre-filled details.
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-01: Add `subject` prop for customizable email subjects. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { useCallback } from "react";
import { MailTo } from "./UtilityComponents";

export default function ReportAnIssue({
    mail = "cwyeh@eda.ee.ntu.edu.tw",
    children,
    subject = "Problem Report",
    style = null
}) {
    const getReportBody = useCallback(() => {
        const url = typeof window !== "undefined" ? window.location.href : "";
        const ua  = typeof navigator !== "undefined" ? navigator.userAgent : "";
        return [
            "Describe the issue here:",
            "",
            `Page: ${url}`,
            `User-Agent: ${ua}`,
        ].join("\n");
    }, []);

    return (
        <MailTo
            mail={mail}
            subject={`[NTU EDA Lab Website] ${subject}`}
            body={getReportBody()}
            style={style}
        >
            {children}
        </MailTo>
    );
}
